import { render, staticRenderFns } from "./video.vue?vue&type=template&id=af01cd2c&scoped=true&"
var script = {}
import style0 from "./video.vue?vue&type=style&index=0&id=af01cd2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af01cd2c",
  null
  
)

export default component.exports